import { render } from "./KinematicsGraphDinamic.vue?vue&type=template&id=e536bc96&ts=true"
import script from "./KinematicsGraphDinamic.vue?vue&type=script&lang=ts"
export * from "./KinematicsGraphDinamic.vue?vue&type=script&lang=ts"

import "./KinematicsGraphDinamic.vue?vue&type=style&index=0&id=e536bc96&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__